var _circle, _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotostep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C12.6124 -4.03972e-08 9.31214 1.07524 6.57467 3.07084C3.83721 5.06644 1.8038 7.87941 0.767304 11.1046C-0.269188 14.3298 -0.255262 17.8007 0.807077 21.0175C1.86942 24.2342 3.92534 27.0308 6.67872 29.0044L7.83457 27.3918C5.4226 25.663 3.62161 23.2132 2.69101 20.3953C1.7604 17.5774 1.7482 14.5369 2.65617 11.7116C3.56413 8.88637 5.3454 6.42221 7.74342 4.67406C10.1414 2.92591 13.0324 1.98401 16 1.98401V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C12.6124 -4.03972e-08 9.31214 1.07524 6.57467 3.07084C3.83721 5.06644 1.8038 7.87941 0.767304 11.1046C-0.269188 14.3298 -0.255262 17.8007 0.807077 21.0175C1.86942 24.2342 3.92534 27.0308 6.67872 29.0044L7.83457 27.3918C5.4226 25.663 3.62161 23.2132 2.69101 20.3953C1.7604 17.5774 1.7482 14.5369 2.65617 11.7116C3.56413 8.88637 5.3454 6.42221 7.74342 4.67406C10.1414 2.92591 13.0324 1.98401 16 1.98401V0Z",
    stroke: "#50949E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 10H11.3333C10.597 10 10 10.597 10 11.3333V20.6667C10 21.403 10.597 22 11.3333 22H20.6667C21.403 22 22 21.403 22 20.6667V11.3333C22 10.597 21.403 10 20.6667 10Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 14.667C14.2203 14.667 14.668 14.2193 14.668 13.667C14.668 13.1147 14.2203 12.667 13.668 12.667C13.1157 12.667 12.668 13.1147 12.668 13.667C12.668 14.2193 13.1157 14.667 13.668 14.667Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 18.0003L18.6654 14.667L11.332 22.0003",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotostep);
export default __webpack_public_path__ + "static/media/photostep.5b21215f18aa664bd38320bc125ecf3d.svg";
export { ForwardRef as ReactComponent };